import { Href, Redirect } from 'expo-router';
import React, { useEffect, useState } from 'react';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';
import { isWeb } from 'shared/constants/platform';
import { useAuth } from 'shared/providers/auth';
import { isUserAuthenticated } from 'shared/utils/useIsUserAuthenticated/useIsUserAuthenticated';

export default function Index() {
  const { isLoggedIn, loginEvaluated } = useAuth();
  const [hasRefreshToken, setHasRefreshToken] = useState<boolean | null>(null);

  useEffect(() => {
    isUserAuthenticated()
      .then(setHasRefreshToken)
      .catch(() => setHasRefreshToken(false));
  }, []);

  const isLoading = !loginEvaluated || hasRefreshToken === null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  const initialRoute =
    !isWeb && !hasRefreshToken ? '/(public)/welcome/' : '/(public)/login/';

  const href = (isLoggedIn ? '/(authenticated)/(tabs)/' : initialRoute) as Href;

  return <Redirect href={href} />;
}
